import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-fairguard",
  "use": "icon-fairguard-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-fairguard\"><defs><style type=\"text/css\"></style></defs><path d=\"M792 209.1c-112.8-10.2-198.2-70.5-239-99.9-9.8-7.1-21.2-10.8-33-10.8-14.2 0-28.2 5.5-39.3 15.6-68.7 62.1-183.8 88.8-246.3 93.6-30.8 2.3-55 30.2-55 63.5v264.3c0 126.5 188.1 392.7 335.7 392.7 154.5 0 331.5-271.8 331.5-382.9V272.4c0-33.4-23.5-60.6-54.6-63.3zM665.5 546.3H546.2v119.3c0 18.3-14.9 33.2-33.2 33.2-18.3 0-33.2-14.9-33.2-33.2V546.3H360.5c-18.3 0-33.2-14.9-33.2-33.2s14.9-33.2 33.2-33.2h119.3V360.7c0-18.3 14.9-33.2 33.2-33.2 18.3 0 33.2 14.9 33.2 33.2V480h119.3c18.3 0 33.2 14.9 33.2 33.2s-14.9 33.1-33.2 33.1z\" fill=\"#3259CE\" p-id=\"4936\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/fairguard.svg
// module id = RBZB
// module chunks = 78